type Props = { value: number; label?: string }

export function ProgressRing({ value, label = 'Today’s progress' }: Props) {
  const safe = Math.max(0, Math.min(100, value))
  return (
    <div className="progress-ring" style={{ '--progress': `${safe * 3.6}deg` } as React.CSSProperties} aria-label={`${label} ${safe}%`}>
      <div><strong>{safe}%</strong><span>{label}</span></div>
    </div>
  )
}
